import { z } from "zod";
import { AuthProviderSchema } from "./user";

export const SessionDataSchema = z.object({
  userId: z.string().uuid(),
  provider: AuthProviderSchema,
  createdAt: z.number().int(),
  expiresAt: z.number().int(),
  userAgent: z.string(),
  ip: z.string(),
});
export type SessionData = z.infer<typeof SessionDataSchema>;
